module.exports = __webpack_public_path__ + "img/why-vpn-changes-ip-address.5581645c.png";